inputs-complex-search-comma
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | { opts.label }
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      .d-flex.value-wrap
        input(name="{ opts.name }" type="hidden" value="{ opts.value }")
        .labels-wrap
          span.label.label-info.job-no(each="{item in opts.items}" data-id="{item.order_id}" onClick="{onClickJobno}")
            | { item.job_no }&nbsp;
            i.feather.icon-x-circle
        inputs-without-label-typeahead(tag-scope="{this.tagScope}.typeahead" onSelect="{onSelect}")
  script(type="typescript").
    this.mixin('inputs.complex.search-comma');
  style(scoped).
    .job-no {
      cursor: pointer;
      margin-bottom: 1px;
      display: inline-block;
    }
    inputs-without-label-typeahead {
      display: block;
      min-width: 80px;
    }
    .value-wrap {
      flex-wrap: wrap;
    }
